if (!customElements.get('zenvana-highlights')) {
  customElements.define('zenvana-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.z-highlights__track');
      const items = this.querySelector('.z-highlights__items');
      const pause = this.querySelector('button');
      const copy = items.cloneNode(true);
      copy.classList.add('z-highlights__copy');
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
      track.append(copy);
      this.classList.add('is-moving');
      pause.hidden = false;
      pause.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? 'Resume scrolling offers' : 'Pause scrolling offers');
        pause.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      });
      this.addEventListener('focusin', event => {
        if (items.contains(event.target) && event.target.matches(':focus-visible')) {
          track.style.animation = 'none';
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          track.style.animation = '';
          this.querySelector('.z-highlights__window').scrollLeft = 0;
        }
      });
    }
  });
}
